var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addEditForm" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, "label-width": "170px", rules: _vm.rules },
        },
        [
          _c(
            "el-row",
            { staticClass: "marRight20" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "课程名称", prop: "courseName" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.courseName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "courseName", $$v)
                      },
                      expression: "form.courseName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "主持老师", prop: "courseEmceeName" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.courseEmceeName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "courseEmceeName", $$v)
                      },
                      expression: "form.courseEmceeName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "专业大类", prop: "fkCourseMajor" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择专业大类" },
                      model: {
                        value: _vm.form.fkCourseMajor,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "fkCourseMajor", $$v)
                        },
                        expression: "form.fkCourseMajor",
                      },
                    },
                    _vm._l(_vm.prolist, function (i) {
                      return _c("el-option", {
                        key: i.id,
                        attrs: { label: i.majorName, value: i.majorName },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.$store.state.user.userInfo.roleType == 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "学校", prop: "schoolId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "学校" },
                          model: {
                            value: _vm.form.schoolId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "schoolId", $$v)
                            },
                            expression: "form.schoolId",
                          },
                        },
                        _vm._l(_vm.schoolListData, function (i) {
                          return _c("el-option", {
                            key: i.id,
                            attrs: { label: i.name, value: i.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "学习人数", prop: "studyNum" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入学习人数",
                      maxlength: "10",
                      "show-word-limit": "",
                    },
                    on: {
                      input: function (e) {
                        return (_vm.form.studyNum = _vm.isnumber(e))
                      },
                    },
                    model: {
                      value: _vm.form.studyNum,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "studyNum", $$v)
                      },
                      expression: "form.studyNum",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "课程封面：" } },
                [
                  _c("file-upload", {
                    staticClass: "img",
                    attrs: { accept: _vm.accept },
                    on: { successUpLoad: _vm.successUpLoad },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "课程链接", prop: "courseLink" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.courseLink,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "courseLink", $$v)
                      },
                      expression: "form.courseLink",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "排序", prop: "sort" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "10",
                      "show-word-limit": "",
                      placeholder: "请输入排序",
                    },
                    on: {
                      input: function (e) {
                        return (_vm.form.sort = _vm.isnumber(e))
                      },
                    },
                    model: {
                      value: _vm.form.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "sort", $$v)
                      },
                      expression: "form.sort",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "项目级别", prop: "courseLevel" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择项目级别" },
                      model: {
                        value: _vm.form.courseLevel,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "courseLevel", $$v)
                        },
                        expression: "form.courseLevel",
                      },
                    },
                    _vm._l(_vm.courseLevelList, function (i) {
                      return _c("el-option", {
                        key: i,
                        attrs: { label: i, value: i },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "层次", prop: "schoolLevel" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择层次" },
                      model: {
                        value: _vm.form.schoolLevel,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "schoolLevel", $$v)
                        },
                        expression: "form.schoolLevel",
                      },
                    },
                    _vm._l(_vm.schoolLevel, function (i) {
                      return _c("el-option", {
                        key: i.value,
                        attrs: { label: i.name, value: i.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "年份" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择年份" },
                      model: {
                        value: _vm.form.year,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "year", $$v)
                        },
                        expression: "form.year",
                      },
                    },
                    _vm._l(_vm.yearList, function (i) {
                      return _c("el-option", {
                        key: i.id,
                        attrs: { label: i.name, value: i.name },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "课程来源" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择课程来源" },
                      model: {
                        value: _vm.form.origin,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "origin", $$v)
                        },
                        expression: "form.origin",
                      },
                    },
                    _vm._l(_vm.courseList, function (i) {
                      return _c("el-option", {
                        key: i.id,
                        attrs: { label: i.name, value: i.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "类型" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择类型" },
                      model: {
                        value: _vm.form.courseType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "courseType", $$v)
                        },
                        expression: "form.courseType",
                      },
                    },
                    _vm._l(_vm.typeList, function (i) {
                      return _c("el-option", {
                        key: i.value,
                        attrs: { label: i.name, value: i.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "submitBtn" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: {
                click: function ($event) {
                  return _vm.submit("form")
                },
              },
            },
            [_vm._v("确定")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.isBack } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }